<template>
  <div id="auth" class="row">
    <div class="col">
      <div class="row">
        <div class="col">
          <div id="logo"></div>
        </div>
      </div>
      <div class="row sized-top-20">
        <div class="col">
          <div id="form" class="row justify-content-md-center">
            <div class="col-md-auto">
              <div class="form-group" v-if="auth_confirmation == null">
                <label for="form_phone">Seu celular:</label>
                <input
                  v-model="form_phone"
                  v-mask="'(##) # ####-####'"
                  type="tel"
                  class="form-control"
                  id="form_phone"
                  aria-describedby="phoneHelp"
                  placeholder="digite aqui"
                />
                <small
                  id="phoneHelp"
                  v-bind:class="
                    (form_phone == ''
                      ? 'text-muted'
                      : validatePhone(form_phone)
                      ? 'text-success'
                      : 'text-danger') + ' form-text'
                  "
                  >*
                  {{
                    form_phone == ""
                      ? "Seu número é necessário para o login"
                      : validatePhone(form_phone)
                      ? "Número válido"
                      : "Número inválido"
                  }}</small
                >
              </div>
              <div class="form-group" v-else>
                <label for="form_code">Digite o código recebido por SMS:</label>
                <input
                  v-model="form_code"
                  v-mask="'# # # # # #'"
                  type="tel"
                  class="form-control"
                  id="form_code"
                  aria-describedby="codeHelp"
                  placeholder="digite aqui"
                />
                <small
                  id="codeHelp"
                  v-bind:class="
                    (form_code == ''
                      ? 'text-muted'
                      : validateCode(form_code)
                      ? 'text-success'
                      : 'text-danger') + ' form-text'
                  "
                  >*
                  {{
                    form_code == ""
                      ? "Código necessário para confirmar sua identidade"
                      : validateCode(form_code)
                      ? "Código válido"
                      : "Código inválido"
                  }}</small
                >
              </div>
            </div>
          </div>
          <div class="row justify-content-md-center">
            <div class="col-md-auto" v-show="auth_confirmation == null">
              <button id="get-sign-in-code" type="button" class="btn btn-dark">
                Entrar
              </button>
            </div>
            <div class="col-md-auto" v-show="auth_confirmation != null">
              <button
                id="sign-in"
                type="button"
                class="btn btn-dark"
                v-bind:disabled="form_code_valid.length < 6"
                v-on:click="sendCode()"
              >
                Continuar
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { firebase, auth } from "../configs/firebase.js";

export default {
  name: "Auth",
  data() {
    return {
      auth_confirmation: null,
      form_phone: "",
      form_code: "",
      form_phone_valid: "",
      form_code_valid: "",
    };
  },
  methods: {
    validatePhone(phone) {
      let x = phone.replace(/[^0-9]+/g, "");
      if (x.length == 11) {
        this.form_phone_valid = x;
        return true;
      }
      return false;
    },
    validateCode(code) {
      let x = code.replace(/[^0-9]+/g, "");
      if (x.length == 6) {
        this.form_code_valid = x;
        return true;
      }
      return false;
    },
    async sendSMS() {
      try {
        let response = await auth.signInWithPhoneNumber(
          "+55" + this.form_phone_valid,
          window.recaptchaVerifier
        );
        this.auth_confirmation = response;
      } catch (e) {
        if (e.code == "auth/invalid-phone-number") {
          alert("Número de celular inválido");
        } else {
          alert("Erro ao validar seu número, tente novamente (" + e.code + ")");
        }
      }
    },
    async sendCode() {
      try {
        await this.auth_confirmation.confirm(this.form_code_valid);
      } catch (e) {
        if (e.code == "auth/invalid-verification-code") {
          alert("O código digitado é inválido, verifique o SMS");
        } else {
          alert("Erro ao obter código, tente novamente (" + e.code + ")");
        }
      }
    },
  },
  mounted() {
    window.recaptchaVerifier = new firebase.auth.RecaptchaVerifier(
      "get-sign-in-code",
      {
        size: "invisible",
        callback: () => {
          this.sendSMS();
        },
      }
    );

    window.recaptchaVerifier.render().then((widgetId) => {
      window.recaptchaWidgetId = widgetId;
    });
  },
};
</script>

<style>
#auth {
  width: 912px;
  margin: 20px auto;
  text-align: center;
  padding: 10px;
}

#logo {
  position: relative;
  left: calc(50% - 100px);
  width: 200px;
  height: 200px;
  background-image: url("../assets/logo.png");
  background-size: 100% 100%;
}

#form_phone {
  min-width: 300px;
}

@media only screen and (max-width: 912px) {
  #auth {
    width: 100%;
    padding: 0px;
  }
  #form_phone {
    min-width: 0px;
  }
}
</style>
